import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import type { ReduxState } from "@dashboard/types";
import { shouldIgnoreShortcut } from "@dashboard/utils/shouldIgnoreShortcut";

// Cmd/Ctrl+Shift+. takes an admin to the /admin shell. Mounted (admin-only)
// high in the tree so the listener is always available.
export const AdminShortcut = () => {
  const userIsAdmin = useSelector(
    (state: ReduxState) => state.dashboardApp.userIsAdmin
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (!userIsAdmin) {
      return;
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey &&
        (event.key === "." || event.key === ">") &&
        !shouldIgnoreShortcut()
      ) {
        event.preventDefault();
        navigate("/admin");
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [userIsAdmin, navigate]);

  return null;
};
